module.exports = __webpack_public_path__ + "img/pop-income01.4a71cfbf.jpg";